import React, { useState } from "react";
import Image from "next/image";
import content from "../../_utilities/data/sections/product-details.json";

interface LatestProduct {
  selectedProductIndex: number;
}
const ProductDetails: React.FC<LatestProduct> = ({selectedProductIndex}) => {

  return (
    <>
      {content.map((item, index) => (
        <section key={index} >
                {selectedProductIndex === index && (
          <><section className="mil-deep-bg">
              <div className="container">
                <div className="row justify-content-between align-items-center">
                  <div className="col-lg-7 p-2">
                    <div>
                      <div className=" mt-5 mb-4">
                        <Image
                          src={item.serviceFor.imageSrc}
                          alt={item.serviceFor.imageAlt}
                          width={1000}
                          height={500}
                          className="mil-image-frame1" />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-5 p-3">
                    <h2 className="mil-mb-30 mil-h2 ">
                      <span className="mil-accent">{item.serviceFor.heading}</span>{" "}
                    </h2>
                    <p className="mil-mb-50 mil-dig-text" style={{textAlign:"justify"}}>{item.serviceFor.description}</p>
                    <div className="row align-items-end">
                      <div className="col-xl">
                        <ul className="mil-check-icon-list mil-mb-60 product-list-grid">
                          {item.serviceFor.features.map((feature, index) => (
                            <li key={index}>
                              <Image src={feature.iconSrc} alt="icon" width={20} height={20} />
                              <span className="mil-dark mil-font-2">{feature.label}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section><div className="container">
                <section className="mil-team">
                  <div className="container">
                    <div className="row justify-content-between">
                      <div className="col-md-12 col-lg-12 col-xl-12" style={{marginTop:"30px"}}>
                        <h2 className="mil-mb-40 mil-h2">
                          <span className="mil-accent">Key Features</span>{" "}
                        </h2>
                        <ul className="mil-timeline">
                          {item.keyFeatures.first.map((feature, index) => (
                            <li key={index}>
                              <p className="mil-mb-5 mil-h5">
                                {feature.title}
                              </p>
                              {/* <h5 className="mil-mb-5 mil-h5">{feature.title}</h5> */}
                            </li>
                          ))}
                        </ul>
                        <ul className="mil-timeline">
                          {item.keyFeatures.Second.map((feature, index) => (
                            <li key={index}>
                              <p className="mil-mb-5 mil-h5">
                                {feature.title}
                              </p>
                              {/* <h5 className="mil-mb-5 mil-h5">{feature.title}</h5> */}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </section>
              </div></>
          )}
        </section>
      ))}
    </>
  );
};

export default ProductDetails;
